import { emit, reconnectWithToken, disconnectSocket } from '../socket';

const AuthService = {
  login: async (deviceId, key) => {
    const response = await emit('auth:login', { deviceId, key });
    const token = response.data.access_token;
    localStorage.setItem('token', token);
    await reconnectWithToken(token);
    return token;
  },
  checkDevice: async (deviceId) => {
    const response = await emit('auth:checkDevice', { deviceId });
    return response.data;
  },
  register: async (deviceId, pin) => {
    const response = await emit('auth:register', { deviceId, pin });
    const token = response.data.access_token;
    localStorage.setItem('token', token);
    await reconnectWithToken(token);
    return token;
  },
  resetPassword: async (newPin) => {
    await emit('auth:resetPassword', { newPin });
  },
  logout: () => {
    localStorage.removeItem('token');
    disconnectSocket();
  },
  quickRegister: async (name) => {
    const response = await emit('auth:quickRegister', { name });
    const token = response.data.access_token;
    localStorage.setItem('token', token);
    await reconnectWithToken(token);
    return token;
  },
};

export default AuthService;
